export const PageRoutes = {
    dashboard: `/visa-process/dashboard`,
    forgotPassword: '/password-recovery',
};
